import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

function Main() {
    return(
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Research"/>
            <section className="project-detail">
                <div className='container'>
                    <div className="c-heading">
                        <h1>Research</h1> <br/>
                    </div>
                    <h4 className='mb-3'>The thrust areas for research @ IIT Tirupati would be the following: </h4>
                    <ul className='myulcustarrow'>
              <li> <Link>Smart Infrastructure</Link> </li>
              <li> <Link>Food Science & Engineering</Link></li>
              <li> <Link>Material Science & Engineering</Link> </li>
              <li> <Link>Energy</Link></li>
              <li> <Link>Education Technology</Link></li>
              <li> <Link>Design</Link></li>
              
            </ul>
     


                </div>
            </section>
        </>
    );
}

export default Main;